import { defineNuxtRouteMiddleware, useOidcClient } from '#imports';

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) return;

  const oidcClient = useOidcClient()();
  const user = await oidcClient.getUser();
  const userRoles = user?.profile?.roles ?? user?.roles ?? {};

  if (!Object.entries(userRoles).some((role) => role.includes('media'))) {
    return abortNavigation();
  }
});
